import {createContext, useContext, useState} from 'react'
import {useSearchableMembers} from '../hooks/members/useSearchableMembers'
import {SearchType} from '../pages/search/types'

interface SearchParams {
  where: string
  keywords: string
  category?: string
  // Global Search (Search01): the single query text and selected type. Added ALONGSIDE the legacy
  // where/keywords so the existing members + experiences flow keeps working unchanged — the header
  // mirrors the query into `keywords`. The results page reads `query`/`type` (or the URL) in PR 4.
  query?: string
  type?: SearchType
}

interface SearchableMembersState {
  data?: any | null
  loading: boolean
  error?: Error | null
  searchParams: SearchParams
  setSearchParams: React.Dispatch<React.SetStateAction<SearchParams>>
}

const SearchableMembersContext = createContext<SearchableMembersState | undefined>(undefined)

export const SearchableMembersProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [searchParams, setSearchParams] = useState<SearchParams>({
    where: '',
    keywords: '',
    category: '',
    query: '',
    type: 'all',
  })

  const {data, error, loading} = useSearchableMembers(searchParams.where, searchParams.keywords, searchParams.category ?? '')

  return (
    <SearchableMembersContext.Provider
      value={{data, loading, error, searchParams, setSearchParams}}
    >
      {children}
    </SearchableMembersContext.Provider>
  )
}

export const useSearchableMembersContext = () => {
  const ctx = useContext(SearchableMembersContext)
  if (!ctx)
    throw new Error('useSearchableMembersContext must be used inside SearchableMembersProvider')
  return ctx
}
